"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var format_1 = __importDefault(require("date-fns/format"));

var parse_1 = __importDefault(require("date-fns/parse"));

var react_1 = __importDefault(require("react"));

var DayPickerInput_1 = __importDefault(require("react-day-picker/DayPickerInput"));

var config_1 = require("../config");

var Input_1 = __importStar(require("../Input"));

var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));

var Overlay_1 = __importDefault(require("./Overlay"));

var YearMonthForm_1 = require("./YearMonthForm");

var currentYear = new Date().getFullYear();

exports.isDate = function (value) {
  return value instanceof Date && !isNaN(value.valueOf());
};

exports.parseDate = function (str, format) {
  // Remove leading zeros
  var parsed = parse_1.default(str.replace(/\.\s*0*/g, '.').replace(/\-\s*0*/g, '-'), format.replace(/\s*/g, ''), new Date());

  if (exports.isDate(parsed)) {
    return parsed;
  }

  return undefined;
};

exports.formatDate = function (date, format) {
  return format_1.default(date, format);
}; // tslint:disable-next-line:max-classes-per-file


var DatePicker =
/** @class */
function (_super) {
  __extends(DatePicker, _super);

  function DatePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.input = null;
    _this.contentRef = react_1.default.createRef();

    _this.localeChanged = function () {
      _this.forceUpdate();
    };
    /**
     * Method which check if month is changed.
     */


    _this.handleYearMonthChange = function (month) {
      _this.setState({
        month: month
      });
    };

    _this.handleDayClick = function (day) {
      if (!_this.props.onChange) {
        return;
      }

      if (day === undefined) {
        _this.props.onChange('', null);
      } else {
        _this.props.onChange(exports.formatDate(day, LocaleProvider_1.default.locs.date_picker.format), day);
      }
    };

    _this.state = {
      month: new Date()
    };
    LocaleProvider_1.default.on(_this.localeChanged);
    return _this;
  }

  DatePicker.prototype.componentWillUnmount = function () {
    LocaleProvider_1.default.off(this.localeChanged);
  };

  DatePicker.prototype.dayPickerProps = function () {
    var _this = this;

    var pickerProps = __assign(__assign({}, LocaleProvider_1.default.locs.date_picker.strings), {
      showOutsideDays: true
    });

    var fromMonth = this.props.fromMonth || new Date(currentYear - 10, 0);
    var toMonth = this.props.toMonth || new Date(currentYear + 10, 11);
    pickerProps.showOutsideDays = true;
    pickerProps.fixedWeeks = true;

    if (!this.props.hideYearNavigation) {
      pickerProps.month = this.state.month;
      pickerProps.fromMonth = fromMonth;
      pickerProps.toMonth = toMonth;

      pickerProps.captionElement = function (_a) {
        var date = _a.date,
            localeUtils = _a.localeUtils;
        return react_1.default.createElement(YearMonthForm_1.YearMonthForm, {
          date: date,
          fromMonth: fromMonth,
          toMonth: toMonth,
          localeUtils: localeUtils,
          onChange: _this.handleYearMonthChange
        });
      };
    }

    return pickerProps;
  };

  DatePicker.prototype.render = function () {
    var _this = this;

    var variant = this.props.variant;
    var format = LocaleProvider_1.default.locs.date_picker.format || 'dd/M/y';
    var b = config_1.block('input_datepicker');
    var cn = b({
      white: variant === Input_1.InputVariant.White,
      grey: variant === Input_1.InputVariant.Grey
    });

    if (this.props.disabled) {
      var value = void 0;

      if (this.props.value instanceof Date) {
        value = exports.formatDate(this.props.value, format);
      } else if (this.props.value) {
        var date = exports.parseDate(this.props.value, format);

        if (date) {
          value = exports.formatDate(date, format);
        }
      }

      return react_1.default.createElement(Input_1.default, {
        disabled: true,
        value: value
      });
    } else {
      // tslint:disable:jsx-no-lambda
      return react_1.default.createElement("div", {
        ref: this.contentRef
      }, react_1.default.createElement(DayPickerInput_1.default, {
        ref: function ref(el) {
          return _this.input = el;
        },
        formatDate: exports.formatDate,
        hideOnDayClick: this.props.hideOnDayClick,
        onDayChange: this.handleDayClick,
        value: this.props.value,
        format: format,
        parseDate: exports.parseDate,
        inputProps: {
          className: cn
        },
        overlayComponent: function overlayComponent(args) {
          return react_1.default.createElement(Overlay_1.default, __assign({
            containerRef: _this.contentRef
          }, args));
        },
        placeholder: "" + format_1.default(new Date(), format),
        dayPickerProps: this.dayPickerProps(),
        keepFocus: false
      }));
    }
  };

  DatePicker.defaultProps = {
    variant: Input_1.InputVariant.Grey
  };
  return DatePicker;
}(react_1.default.Component);

exports.default = DatePicker;